import type { SerializedError } from "@reduxjs/toolkit";

import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import initialConfig from "../initialConfig";

const initialState = {
  getOrdersData: {},
  getOrdersLoading: false,
  getOrdersError: null as SerializedError | null,
};

interface IGetOrders {
  accessToken: string;
}

export const getOrdersFunc = createAsyncThunk("getOrders/getOrdersFunc", async (values: IGetOrders) => {


  const data1 = JSON.stringify({
    query: `query Parent_orders($filter: FilterOrderInput) {
      parent_orders(filter: $filter) {
        data {
          _id
          orderStatus
          activity {
            id
          }
          reservationId
          payment {
            paymentStatus
            token
            creationData
          }
        }
      }
    }`,
    variables: {
      "filter": {
        "reservationId": null
      }
    }
  });

  const config = initialConfig('https://api.hophop.com.tr/payment/graphql', data1, values.accessToken);

  const response = axios(config).then((res) => {
    const data = res.data;
    return data;
  }).catch((err) => err);

  const data = await response;
  return data;
});


const getOrders = createSlice({
  name: "getOrders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOrdersFunc.pending, (state) => {
      state.getOrdersLoading = true;
    });
    builder.addCase(getOrdersFunc.fulfilled, (state, action) => {
      state.getOrdersLoading = false;
      state.getOrdersData = action.payload?.data?.parent_orders?.data?.[0];
      state.getOrdersError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(getOrdersFunc.rejected, (state, action) => {
      state.getOrdersLoading = false;
      state.getOrdersError = action.error;
    });
  }
});

export default getOrders.reducer;